import MyTable from '../../../components/MyTable';
import React from 'react';
import { connect } from 'react-redux';
import {compose} from "redux";
import { withRouter } from "react-router-dom";
import {
    initializeDataTable,
    nextPage,
    previousPage,
    changePerPage,
    sort,
    setActiveUser
} from '../../../actions/userActions';
import UsersFilter from "./UsersFilter";


const mapStateToProps = (state) => {
    let { page, perPage, totalRecords, isFetching, sortDirection, sortField } = state.user;
    let data = state.user.data ? state.user.data : [];

    const fields = {
        "Vorname": "firstname",
        "Nachname": "lastname",
        "Email": "email",
        "Rolle": "role",
        "Status": "status_text"
    };

    const idField = "id";

    const click = true;

    return {
        page,
        perPage,
        totalRecords,
        data,
        loading: isFetching,
        sortDirection,
        sortField,
        fields,
        idField,
        filterComponent: () => <UsersFilter />,
        click,
        sortFields: ['email', 'firstname', 'lastname', 'role']
    };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        initializeDataTable,
        nextPage: () => { dispatch(nextPage())},
        previousPage: () => {dispatch(previousPage())},
        changePerPage: (value => { dispatch(changePerPage(value))}),
        sort: (field, value) => { dispatch(sort(field, value))},
        onClickRow: (rowData) => {
            dispatch(setActiveUser(rowData));
        },
    };
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(MyTable)
